import { render, staticRenderFns } from "./PonBox.vue?vue&type=template&id=161a4784&scoped=true"
import script from "./PonBox.vue?vue&type=script&lang=js"
export * from "./PonBox.vue?vue&type=script&lang=js"
import style0 from "./PonBox.vue?vue&type=style&index=0&id=161a4784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161a4784",
  null
  
)

export default component.exports